/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDeactivateWizerRequest
 */
export interface ControlDeactivateWizerRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlDeactivateWizerRequest
     */
    client_id: string;
}

/**
 * Check if a given object implements the ControlDeactivateWizerRequest interface.
 */
export function instanceOfControlDeactivateWizerRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlDeactivateWizerRequestFromJSON(json: any): ControlDeactivateWizerRequest {
    return ControlDeactivateWizerRequestFromJSONTyped(json, false);
}

export function ControlDeactivateWizerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDeactivateWizerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
    };
}

export function ControlDeactivateWizerRequestToJSON(value?: ControlDeactivateWizerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
    };
}

